module.exports = __webpack_public_path__ + "img/BOWTIE 3 LIME.cf0455f.svg";